import React from 'react';
import { XIcon } from 'lucide-react';
import { problems } from '../data/comparison';
import { SectionHeading } from './SectionHeading';
export function Problems() {
  return <section aria-labelledby="problems-heading" className="bg-mist py-16 sm:py-24" data-id="element-145" data-mp="32515g7p8tv9n">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-146" data-mp="322ofb79c0eli">
        <SectionHeading id="problems-heading" tone="light" data-id="element-147" data-mp="2y2e7rq5w5g4j">
          Jeśli uczysz gitary jazzowej, <span className="text-gold-dark" data-id="element-148" data-mp="2t5e3nkslqng2">pewnie znasz przynajmniej jeden z tych problemów.</span>
        </SectionHeading>
        <ul className="mt-10 grid gap-4 sm:mt-14 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5" data-id="element-149" data-mp="2o3osm55dq9rz">
          {problems.map(problem => <li key={problem} className="flex items-start gap-4 rounded-2xl border border-copy-dark/10 bg-white p-5 shadow-card sm:p-6" data-id="element-150" data-mp="2j7zwycwhdd0y">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-danger/10" data-id="element-151" data-mp="hf3gubnprk9z">
                <XIcon className="h-5 w-5 text-danger" aria-hidden="true" data-id="element-152" data-mp="de9on638njba" />
              </span>
              <p className="text-base font-medium leading-snug text-copy-dark" data-id="element-153" data-mp="34ptmy1jc3dvd">{problem}</p>
            </li>)}
        </ul>
        <p className="mx-auto mt-10 max-w-2xl text-center font-display text-3xl font-bold leading-tight text-copy-dark sm:mt-14 sm:text-4xl" data-id="element-154" data-mp="39r96tq9rzec6">
          Ile jeszcze lekcji chcesz <span className="text-gold-dark" data-id="element-155" data-mp="2zstks1pluv9j">improwizować?</span>
        </p>
      </div>
    </section>;
}